import { useEffect, useState } from 'preact/hooks';
import { openAlert } from '../../../components/alert/useAlert';
import { GET_WITH_RETRY, GET_OPTIONS_BY_TYPE } from '../../../services'

export const useGetOptions = () => {
  const [optionsRegion, setOptionsRegion] = useState([]);
  const [optionsBattery, setOptionsBattery] = useState([]);
  const [optionsAccessories, setOptionsAccessories] = useState([]);
  const [optionsWarranty, setOptionsWarranty] = useState([]);
  const [optionsUsedCondition, setOptionsUsedCondition] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsBookingType, setOptionsBookingType] = useState([]);
  const [optionsDisplayCondition, setOptionsDisplayCondition] = useState([]);
  const [optionsFrameCondition, setOptionsFrameCondition] = useState([]);
  const [optionsBackCoverCondition, setOptionsBackCoverCondition] = useState([]);
  const [optionsBackCameraConditions, setOptionsBackCameraConditions] = useState([]);


  useEffect(() => {
    Promise.all([
      onFetchBytype('region'),
      onFetchBytype('battery'),
      onFetchBytype('accessory'),
      onFetchBytype('warranty'),
      onFetchBytype('usedCondition'),
      onFetchBytype('branch'),
      onFetchBytype('booking'),
      onFetchBytype('displayCondition'),
      onFetchBytype('frameCondition'),
      onFetchBytype('backCoverCondition'),
      onFetchBytype('backCameraConditions'),
    ]);


  }, []);

  const onFetchBytype = async (type) => {
    try {
      const { result, success } = await GET_WITH_RETRY(GET_OPTIONS_BY_TYPE(type));
      if (success) {
        const options = result?.typeOptions.map((el) => {
          return { value: el.key, label: el.label };
        });
        switch (type) {
          case 'region':
            setOptionsRegion(options)
            break;
          case 'battery':
            setOptionsBattery(options)
            break;
          case 'accessory':
            setOptionsAccessories(options)
            break;
          case 'warranty':
            setOptionsWarranty(options)
            break;
          case 'usedCondition':
            setOptionsUsedCondition(options)
            break;
          case 'branch':
            setOptionsBranch(options)
            break;
          case 'booking':
            setOptionsBookingType(options)
            break;
          case 'displayCondition':
            setOptionsDisplayCondition(options)
            break;
          case 'frameCondition':
            setOptionsFrameCondition(options)
            break;
          case 'backCoverCondition':
            setOptionsBackCoverCondition(options)
            break;
          case 'backCameraConditions':
            setOptionsBackCameraConditions(options)
            break;  
        }
      }
    } catch (error) {
      openAlert({
        type: 'error',
        message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      });
    }
  };

  return {
    optionsRegion,
    optionsBattery,
    optionsAccessories,
    optionsWarranty,
    optionsUsedCondition,
    optionsBranch,
    optionsBookingType,
    optionsDisplayCondition,
    optionsFrameCondition,
    optionsBackCoverCondition,
    optionsBackCameraConditions
  };
};
